var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-form',{ref:"app_form_ref",attrs:{"form-data":_vm.form_config},on:{"confirm":_vm.confirm,"cancel":_vm.cancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }